import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("code"),
            field: "employeeCode",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: "employeeName",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("calibratedClassification"),
            field: "calibratedClassificationString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("standardPerformance9boxes"),
            field: "standardPerformanceNineBox",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("calibratedPerformance9boxes"),
            field: "calibratedPerformanceNineBox",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("nineBoxesPerformanceIndicator"),
            field: "indicatorPerformanceNineBox",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: 'IndicatorRenderer'
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("standardPotential9Boxes"),
            field: "standardPotentialNineBox",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("calibratedPotential9boxes"),
            field: "calibratedPotentialNineBox",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("potentialIndicator9boxes"),
            field: "indicatorPotentialNineBox",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: 'IndicatorRenderer'
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("nineBoxClassification"),
            field: "quadrantClassification",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("quadrantClassification"),
            field: "quadrantClassificationCode",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: 'NineBoxImageRenderer'
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("quadrantName"),
            field: "quadrantName",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("recommendation"),
            field: "recommendation",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("calibrationDate"),
            field: "calibrationDate",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },

    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("calibrationResponsible"),
            field: "calibrationResponsible",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("calibrationCommittee"),
            field: "calibrationCommitteeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("calibrationComments"),
            field: "calibrationComments",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("fType"),
            field: "functionaryType",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "workplace",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "workOrTask",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "costCenter",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("SHOW_DIVISION"),
            field: "division",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("management"),
            field: "management",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("department"),
            field: "department",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("position"),
            field: "position",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("function"),
            field: "function",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("category"),
            field: "category",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "contractType",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.nineBoxClassification],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: "contractDate",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
]